import { useEffect } from "react";
import useHistory from "routing/useHistory";
import Route from "./common/Routes";
const GCPInputConfiguration = ({ url = Route.INTEGRATIONS.GCP.ACTIVITYAPI.index }) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default GCPInputConfiguration;
